import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { spaceMixin, mediaMixin, Tabs } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { omitUndefined } from '../../utils/lodash.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './AffordabilityCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './AffordabilityCalculator.utils.js';
import AffordabilityChart from './AffordabilityChart.js';
import AffordabilityFields from './AffordabilityFields.js';
import AffordabilityVisual from './AffordabilityVisual/AffordabilityVisual.js';
import FullReportButton from './FullReportButton.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledCalculatorForm = /*#__PURE__*/styled(CalculatorForm).withConfig({
  componentId: "sc-1wuh2o2-0"
})(["padding-bottom:", ";display:flex;flex-direction:column-reverse;", ";"], spaceMixin('md'), mediaMixin('lg', css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            flex-direction: row;\n            justify-content: space-between;\n        "])))));
var StyledFields = /*#__PURE__*/styled(AffordabilityFields).withConfig({
  componentId: "sc-1wuh2o2-1"
})(["flex-shrink:0;", " ", ""], mediaMixin('md', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n            flex-basis: 30%;\n        "])))), mediaMixin('lg', css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n            margin-right: ", ";\n        "])), spaceMixin('md'))));
var StyledTabsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1wuh2o2-2"
})(["position:relative;", ";"], mediaMixin('md', css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n            flex-basis: 65%;\n        "])))));
var AffordabilityCalculator = function AffordabilityCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  return /*#__PURE__*/React.createElement(StyledCalculatorForm, {
    editorMode: editorMode,
    fieldStorageKey: "affordabilityFields",
    calcTypeForMarketing: "Affordability",
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.customPayment.name] = false, _Object$assign[FieldConfig.maximumPayment.name] = 3500, _Object$assign[FieldConfig.annualIncome.name] = 70000, _Object$assign[FieldConfig.monthlyDebts.name] = 250, _Object$assign[FieldConfig.downPayment.name] = 20000, _Object$assign[FieldConfig.dti.name] = 36, _Object$assign[FieldConfig.rate.name] = 5, _Object$assign[FieldConfig.term.name] = 360, _Object$assign[FieldConfig.includePMI.name] = true, _Object$assign[FieldConfig.includeTaxesInsurance.name] = true, _Object$assign[FieldConfig.propertyTaxRate.name] = 1.2, _Object$assign[FieldConfig.annualHomeownersInsurance.name] = 945, _Object$assign[FieldConfig.monthlyHOA.name] = 0, _Object$assign[FieldConfig.monthlyPayment.name] = 1850, _Object$assign), omitUndefined(defaultValues))
  }, /*#__PURE__*/React.createElement(StyledFields, null), /*#__PURE__*/React.createElement(StyledTabsContainer, null, /*#__PURE__*/React.createElement(Tabs, {
    defaultSelected: "home-price-tab"
  }, /*#__PURE__*/React.createElement(Tabs.List, {
    "aria-label": "Default tabs example"
  }, /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "home-price-tab",
    "aria-controls": "home-price-panel",
    type: "button"
  }, "Home price"), /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "payment-tab",
    "aria-controls": "payment-panel",
    type: "button"
  }, "Payment")), /*#__PURE__*/React.createElement(Tabs.Panels, null, /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "home-price-panel",
    "aria-labelledby": "home-price-tab"
  }, /*#__PURE__*/React.createElement(AffordabilityVisual, null)), /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "payment-panel",
    "aria-labelledby": "payment-tab"
  }, /*#__PURE__*/React.createElement(AffordabilityChart, null)))), /*#__PURE__*/React.createElement(FullReportButton, null)));
};
AffordabilityCalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
AffordabilityCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var AffordabilityCalculator$1 = AffordabilityCalculator;

export { AffordabilityCalculator$1 as default };
